require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/fn/object/assign.js
// module id = 21
// module chunks = 0